module.exports = __webpack_public_path__ + "img/_Compound Path1.8d379e6d.png";